import styled, { css } from "styled-components";
import React from "react";

export interface GridBreakpoint {
    maxWidth: number;
    cols: number;
    rowGap?: number;
    colGap?: number;
}

export interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
    cols?: number;
    rowGap?: number;
    colGap?: number;
    breakpoints?: GridBreakpoint[];
    justifyItems?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline" | "start" | "end";
}

const GridRoot = styled.div<GridProps>`
    display: grid;
    ${({ cols = 1 }) =>
        css`
            grid-template-columns: repeat(${cols}, 1fr);
        `}
    ${({ rowGap }) =>
        rowGap !== undefined &&
        css`
            row-gap: ${rowGap}px;
        `}
    ${({ colGap }) =>
        colGap !== undefined &&
        css`
            column-gap: ${colGap}px;
        `}
    ${({ justifyItems }) =>
        justifyItems &&
        css`
            justify-items: ${justifyItems};
        `}
    ${({ breakpoints }) =>
        breakpoints &&
        breakpoints
            .sort((a, b) => b.maxWidth - a.maxWidth)
            .map(
                (bp) => css`
                    @media (max-width: ${bp.maxWidth}px) {
                        grid-template-columns: repeat(${bp.cols}, 1fr);
                        ${bp.rowGap !== undefined &&
                        css`
                            row-gap: ${bp.rowGap}px;
                        `}
                        ${bp.colGap !== undefined &&
                        css`
                            column-gap: ${bp.colGap}px;
                        `}
                    }
                `
            )}
`;

const Grid: React.FC<GridProps> = ({ children, ...props }) => {
    return <GridRoot {...props}>{children}</GridRoot>;
};

export default Grid;


